var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAirplane(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5673 1.00038C27.3029 0.980389 25.7815 1.75911 24.5133 3.02738C22.4372 4.89587 20.3976 6.9908 18.4322 9.10842L2.21617 5.86521L1 8.29759L13.162 14.3786L6.27021 22.4866C4.68987 21.9668 2.21622 21.3754 2.21622 23.2974C2.21619 23.6773 2.31124 24.0687 2.6216 24.5136L7.48636 29.3784C7.93138 29.6887 8.32273 29.7838 8.70257 29.7838C10.6246 29.7838 10.0331 27.3102 9.51337 25.7298L17.6214 18.838L23.7024 31L26.1348 29.7838L22.8916 13.5678C25.0092 11.6024 27.1041 9.56284 28.9726 7.48674C30.2409 6.21846 31.0196 4.6971 30.9996 3.43273C30.9889 2.7516 30.774 2.10306 30.3379 1.6621C29.897 1.22599 29.2484 1.01116 28.5673 1.00038V1.00038Z",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirplane);
export default __webpack_public_path__ + "static/media/Airplane.c8bff62f.svg";
export { ForwardRef as ReactComponent };